import {
	TableColumn,
	TableConstraintColumn,
} from '@/rtkApi/mddApiSliceGenerated'
import { PossibleForeignKeys } from '@/types'

export interface GetFkSelectOptionsParams {
	possibleForeignKeys: PossibleForeignKeys
	primaryKey: TableColumn
	sortedForeignKeys: TableConstraintColumn[]
}

export const getFkSelectOptions = ({
	primaryKey,
	possibleForeignKeys,
	sortedForeignKeys,
}: GetFkSelectOptionsParams) =>
	possibleForeignKeys?.[String(primaryKey?.uuid)]
		?.map((fk) => ({
			code: fk.code,
			uuid: fk.uuid,
			foreignColumnCode: primaryKey.code,
			foreignColumnUuid: primaryKey.uuid,
		}))
		// do not show columns already used as FK in the same constraint
		.filter(
			(opt) =>
				!sortedForeignKeys.find(
					(cur) =>
						cur.uuid === opt.uuid && cur.foreignColumnUuid !== primaryKey.uuid,
				),
		)
